import { call } from 'typed-redux-saga';

import * as sagaWatchers from './watchers';

const userDestinationsSaga = () => Object.keys(sagaWatchers).map(w => call((sagaWatchers as any)[w])); // todo: fix any

export default userDestinationsSaga;
